<template>
  <div class="left">
    <div
      class="pincode-wrapper"
      v-if="$route.path === '/cart' && getCartCount > 0"
    >
      <p class="mycart" data-test="cartProductListPara"
									id="cartProductListPara">
        My Cart ({{getCartCount}})
      </p>

      <!--PinCode Modal-->
      <!--<div class="pincode-item">-->
      <!--<p>-->
      <!--<i class="fas fa-map-marker-alt"></i>-->
      <!--Pincode-->
      <!--<span>-->
      <!--825554-->
      <!--</span>-->
      <!--</p>-->
      <!--<button data-toggle="modal" data-target="#pincodeModal">-->
      <!--Change-->
      <!--</button>-->
      <!--</div>-->
      <!--PinCode Modal-->

    </div>
    <div class="cart-items-wrapper">
      <cart-product
        v-for="(product, index) in cartProducts"
        :product="product"
        :key="index"
        :index="index"
        :disabled="disabled"
      >
      </cart-product>
      <div
        class="bottom-order-wrapper"
        v-if="getCartCount > 0 && $route.path === '/cart'"
      >
        <button
          type="button"
          name=""
          class="one btn btn-primary btn-type-primary"
          @click.prevent="$router.push('/')"
										data-test="cartProductListContinueBtn"
										id="cartProductListContinueBtn"
        >
          <i class="fas fa-angle-left" data-test="cartProductListContinueBtnI"
													id="cartProductListContinueBtnI"></i>
          Continue Shopping
        </button>
        <button
          type="button"
          name=""
          class="two btn btn-primary btn-type-primary"
          @click.prevent="$router.push('/checkout')"
          :disabled="outOfStock"
          :style="outOfStock? 'cursor: not-allowed;': ''"
										data-test="cartProductListPlaceOrderBtn"
										id="cartProductListPlaceOrderBtn"
        >
          Place order
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import CartProduct from '@/components/pages/cart/cartContainer/cartProductList/cartProduct/CartProduct'
import { mapGetters } from 'vuex'

export default {
	components: {
		CartProduct
	},
	computed: {
		...mapGetters('cart', ['getCartCount', 'getCartProducts']),
		outOfStock () {
			let stock = false
			this.cartProducts.forEach((product) => {
				if (product.stock < 1 || product.product_id === null) {
					stock = true
				}
			})
			return stock
		}
	},
	props: {
		cartProducts: Array,
		cartCount: {
			default: 0,
			type: Number
		},
		disabled: {
			type: Boolean,
			default: false
		}
	}
}
</script>
